export enum EGoodsIds {
  GOODS_CONFIG = 'goods-config',
  GOODS = 'goods',
  SUPPLIERS = 'suppliers',
  MANUAL_ADJUSTMENTS = 'manual-adjustments',
  CONDITIONS = 'conditions',
}

export const goodsPageFragments = [
  {
    title: 'SETTINGS.GOODS.GOODS_CONFIG',
    id: EGoodsIds.GOODS_CONFIG,
  },
  {
    title: 'SETTINGS.GOODS.GOODS',
    id: EGoodsIds.GOODS,
  },
  {
    title: 'SETTINGS.GOODS.SUPPLIERS',
    id: EGoodsIds.SUPPLIERS,
  },
  {
    title: 'SETTINGS.GOODS.MANUAL_ADJUSTMENTS',
    id: EGoodsIds.MANUAL_ADJUSTMENTS,
  },
  {
    title: 'SETTINGS.GOODS.CONDITIONS',
    id: EGoodsIds.CONDITIONS,
  },
];